// @flow
import {
    ACTION_TOGGLE_ETHERPAD,
    ACTION_TOGGLE_WHITE_BOARD,
    OPEN_WHITE_BOARD,
    OPEN_WHITE_BOARD_FINAL,
    TOGGLE_ETHERPAD
} from './actionTypes';

/**
 * Signals a request to display overflow as drawer.
 *
 * @param {boolean} bool - True to display overflow as drawer, false to preserve original behaviour.
 * @returns {{
 *     type: SET_OVERFLOW_DRAWER,
 *     displayAsDrawer: boolean
 * }}
 */
export function toogleEtherPad(bool: boolean) {
    return {
        type: TOGGLE_ETHERPAD,
        bool
    };
}


/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} open - Whether or not a document is currently being.
 * @returns {{
*    type: OPEN_WHITE_BOARD,
*    open: boolean
* }}
*/
export function openWhiteBoardFunction(open) {
    return {
        type: OPEN_WHITE_BOARD,
        open
    };
}

/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} open - Whether or not a document is currently being.
 * @returns {{
*    type: OPEN_WHITE_BOARD_FINAL,
*    open: boolean
* }}
*/
export function openWhiteBoardFinal(open) {
    return {
        type: OPEN_WHITE_BOARD_FINAL,
        open
    };
}

/**
 * Signals a request to display overflow as drawer.
 *
 * @param {boolean} bool - True to display overflow as drawer, false to preserve original behaviour.
 * @returns {{
*     type: ACTION_TOGGLE_ETHERPAD,
*     bool: boolean
* }}
*/
export function actionToggleEtherPad(bool) {
    return {
        type: ACTION_TOGGLE_ETHERPAD,
        bool
    };
}

/**
 * Signals a request to display overflow as drawer.
 *
 * @param {boolean} bool - True to display overflow as drawer, false to preserve original behaviour.
 * @returns {{
*     type: ACTION_TOGGLE_WHITE_BOARD,
*     bool: boolean
* }}
*/
export function actionToggleWhiteBoard(bool) {
    return {
        type: ACTION_TOGGLE_WHITE_BOARD,
        bool
    };
}
